import { useState } from "react";
import { type ClassValue } from "clsx";
import { cn } from "~/lib/utils";
import InfoCircleSvg from "@components/icons/InfoCircle";

interface Props {
  tooltipContent: React.ReactNode;
  id: string;
  width?: number;
  height?: number;
  tooltipClasses?: ClassValue;
}

export default function SimpleTooltip({
  tooltipContent,
  id,
  width = 20,
  height = 20,
  tooltipClasses,
}: Props) {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div className="relative">
      <button
        type="button"
        className={`ml-1 relative ${showTooltip ? "z-50" : ""}`}
        onClick={() => {
          setShowTooltip(!showTooltip);
        }}
        onMouseEnter={() => {
          setShowTooltip(true);
        }}
        onMouseLeave={() => {
          setShowTooltip(false);
        }}
        onKeyDown={(e) => {
          if (e.key === "Escape") {
            setShowTooltip(false);
          }
        }}
      >
        <InfoCircleSvg width={width} height={height} />
      </button>

      {showTooltip && (
        <div role="tooltip" id={id}>
          <div
            className={cn(
              "absolute top-[-16px] left-1/2 transform -translate-x-1/2 -translate-y-full w-max max-w-appWidth z-40 bg-white p-5 rounded-2xl shadow-[2px_6px_8px_0_rgba(0,0,0,0.1)] ]",
              tooltipClasses,
            )}
          >
            <p className="bodySmall text-darkGrey" data-testid="input-info">
              {tooltipContent}
            </p>
            <div
              className={cn(
                "w-0 h-0 absolute bottom-[-6px] left-1/2",
                "transform -translate-x-1/2 z-30",
                "border-l-[8px] border-r-[8px] border-t-[8px]",
                "border-l-transparent border-r-transparent border-t-white",
              )}
            />
          </div>
          <button
            type="button"
            className="w-screen h-screen fixed top-0 left-0 z-40"
            onClick={() => {
              setShowTooltip(false);
            }}
          />
        </div>
      )}
    </div>
  );
}
